import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { hasMinimumRole, hasExactRole } from '../../utils/permissions';
import { ASSESSMENT_TYPES } from '../../config/assessmentConfigs';

const PrivateRoute = ({
  component: Component,
  auth: { isAuthenticated, loading, user },
  requireRole,
  requireExactRole,
  requireModule,
  ...rest
}) => {
  // Check role-based permissions
  const hasRolePermission = () => {
    if (!user || !user.role) return true; // No role requirement

    if (requireExactRole) {
      return hasExactRole(user.role, requireExactRole);
    }

    if (requireRole) {
      return hasMinimumRole(user.role, requireRole);
    }

    return true; // No role requirement specified
  };

  // Module gate: a client whose trainer disabled a module (e.g. nutrition)
  // must not reach that module's routes even via a direct URL / bookmark.
  // Only clients are gated — trainers/admins (including trainer-authoring
  // views of these same routes) always pass. Absent flag ⇒ enabled.
  const hasModuleAccess = () => {
    if (!requireModule) return true;
    if (
      user?.role === 'client' &&
      user?.enabledModules?.[requireModule] === false
    ) {
      return false;
    }
    return true;
  };

  return !loading ? (
    !isAuthenticated ? (
      <Redirect to='/' />
    ) : !hasRolePermission() ? (
      <Redirect to='/unauthorized' />
    ) : !hasModuleAccess() ? (
      <Redirect to='/dashboard/home' />
    ) : !isAuthenticated ? (
      <Redirect to='/' />
    ) : user && user.isAssessmentCompleted ? (
      // TODO: Re-enable subscription check when payment system is implemented
      // Previously: Users with inactive subscriptions were redirected to billing page
      // Temporarily disabled to allow all clients access until payment system is ready
      // Original logic (to restore):
      // user &&
      // !user.isSubscriptionActive &&
      // !hasMinimumRole(user.role, 'trainer') ? (
      //   <Redirect to='/dashboard/settings/billing' />
      // ) : (
      //   <Route {...rest} render={(props) => <Component {...props} />} />
      // )
      <Route {...rest} render={(props) => <Component {...props} />} />
    ) : // Check if user is a trainer - trainers skip assessment
    user && user.role === 'trainer' ? (
      <Route {...rest} render={(props) => <Component {...props} />} />
    ) : // No-assessment users must complete quick setup first
    user &&
      user.assessmentType === ASSESSMENT_TYPES.NONE &&
      user.isAssessmentCompleted ? (
      <Route {...rest} render={(props) => <Component {...props} />} />
    ) : user && user.assessmentType === ASSESSMENT_TYPES.NONE ? (
      <Redirect to='/quick-setup' />
    ) : (
      <Redirect to='/assessment' />
    )
  ) : null;
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(PrivateRoute);
